import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: 100%;
  height: 64px;
  min-height: 64px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  column-gap: 24px;
`;

export const Metrics = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 24px;
`;

export const Metric = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;
